import $ from "jquery";

const popupPDF = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-button-popup",
      popup: "#popup-pdf",
    };

    if ($(el.button).length === 0) return;

    // pass data object to popup
    $(document).on("click", el.button, function () {
      const dataObject =
        $(this).data("item") ?? JSON.parse($(this).find("input").val() ?? null);
      const toggleClassName = $(this).data("toggle_class");
      const forSelector = $(this).data("for");
      const forEl = $(forSelector);
      forEl.toggleClass(toggleClassName);

      if (forEl.hasClass(toggleClassName)) {
        $("body").css("overflow-y", "hidden");
      } else {
        $("body").css("overflow-y", "auto");
      }

      const contentSelector = `${forSelector}__content-pdf`;
      const attributeListsSelector = `${forSelector}__attributes-list`;

      $(contentSelector).html("");
      $(attributeListsSelector).html(""); // Clear attributes list

      const listItemTemplate = $(`${forSelector}__template-list-item`).html();
      const listItemSpecificatiesTemplate = $(
        `${forSelector}__template-list-item-specificaties`
      ).html();
      const listItemAttributesTemplate = $(
        `${forSelector}__template-list-item-attributes`
      ).html();

      if (!dataObject) return;
      const listItem = listItemTemplate
        .replace(
          /{{product_title}}/g,
          dataObject.product_title.length > 0 ? dataObject.product_title : "RAM"
        )
        .replace(/{{product_version}}/g, dataObject.product_version)
        .replace(/{{price}}/g, `Nettoprijs ${dataObject.price}`)
        .replace(/{{image_url}}/g, dataObject.image);

      $(contentSelector).append(listItem);

      $.each(
        dataObject.specificaties.slice().reverse(),
        function (specIndex, specificatie) {
          const listItemSpecificaties = listItemSpecificatiesTemplate
            .replace(/{{section_subtitle}}/g, specificatie.name)
            .replace(/{{section_subtitle_class}}/g, specificatie.name);

          // Append each specificatie
          $(listItemSpecificaties).insertAfter(
            `${forSelector}__divider-headline`
          );
          // Loop through attributes
          $.each(specificatie.attributes, function (attrIndex, attribute) {
            const currentID = `${specIndex}_${attrIndex}`;
            let listItemAttribute = listItemAttributesTemplate
              .replace(/{{attributes_key}}/g, attribute.key)
              .replace(/{{attributes_value}}/g, attribute.value)
              .replace(/{{attributes_price}}/g, attribute.price)
              .replace(/{{id_custom}}/g, currentID);

            if (
              attribute.customize !== null &&
              Object.keys(attribute.customize).length > 0
            ) {
              listItemAttribute = listItemAttribute
                .replace(/{{attributes_is_custom}}/g, true)
                .replace(/{{custom_message}}/g, attribute.customize.message)
                .replace(/{{custom_image}}/g, attribute.customize.file);
            } else {
              listItemAttribute = listItemAttribute
                .replace(/{{attributes_is_custom}}/g, false)
                .replace(/{{custom_message}}/g, "")
                .replace(/{{custom_image}}/g, "");
            }

            // Append each attribute
            $(attributeListsSelector).append(listItemAttribute);
            if (!attribute.customize) {
              $(`${forSelector}__custom-message-${currentID}`).hide();
            }
          });
        }
      );
    });
  };

  init();
};

try {
  popupPDF();
} catch (error) {
  console.error("popup PDF: ", error);
}
